import { ISettings, IVote } from "../../modals/application"

export interface IApplication {
    settings: ISettings,
    dob: string,
    loader: boolean,
    token: string,
    vote: IVote | null
}

export const ACTIONS = {
    GET_SETTINGS_WATCHER: 'SETTINGS_WATCHER',
    GET_SETTINGS_SUCCESS: 'GET_SETTINGS_SUCCESS',
    GET_SETTINGS_ERROR: 'GET_SETTINGS_ERROR',
    UPDATE_AGE_STATE: 'UPDATE_AGE_STATE',
    UPDATE_LOADER: 'UPDATE_LOADER',
    SAVE_VOTE: 'SAVE_VOTE'
}